module.exports = __webpack_public_path__ + "e8d5891f3ae86cb77ddc3aa773aa43e8.MP3";